import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import type { Renderable } from '@adornis/chemistry/renderable.js';
import '@chancenlogistik/client/components/logistik-component-base-header';
import { LogistikPageProductDetails } from '@chancenlogistik/client/pages/logistik-page-product-details.js';
import { LearningMaterial } from '@chancenwerk/db/LogistikProduct.js';
import type { AddResult, NoneResult } from '@chancenwerk/logistik/client/helpers/order-amount-range.js';
import { html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { HefteDialogDisallowedOrderChange } from '../components/hefte-dialog-disallowed-order-change.js';
import { g_getMaxOrderQuantity, g_getTotalOrderQuantity } from '../helpers.js';

/**
 * @element hefte-page-product-details
 */
@customElement('hefte-page-product-details')
export class HeftePageProductDetails extends LogistikPageProductDetails {
  @state() override _totalOrderQuantity = new RXController(this, g_getTotalOrderQuantity());
  @state() override _maxOrderQuantity = new RXController(this, g_getMaxOrderQuantity());

  override _additionalCartButton(): Renderable {
    if (this._product.value instanceof LearningMaterial && this._product.value.digitalVariantPDFID)
      return html`
        <cr-button icon="add_shopping_cart" ${css({ flex: 11 })} @click=${() => this._onAddToCartClicked(true)}>
          Digitales Heft hinzufügen
        </cr-button>
      `;
    return nothing;
  }

  override async handleDisallowedChange(allowedChange: AddResult | NoneResult) {
    return await HefteDialogDisallowedOrderChange.showPopup({
      props: {
        allowedChange,
        product: this._product.value!,
      },
    }).catch(() => false);
  }
}
